// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"styles_imageContainer__feTur","image":"styles_image__IFa29"};